import React from 'react'

export default class Inicio extends React.Component {
    render() {
        return (
            <React.Fragment>
                {this.renderCpf()}
                <div className="form-group row mt-4 text-left">
                    <label className="col-3 col-md-2">Processo:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <input type="text" className="form-control"
                            name="processo"
                            {...this.props}
                            value={this.props.value.numero} />
                    </div>
                </div>
            </React.Fragment>
        )
    }

    renderCpf() {
        if (this.props.value.cpfCnpj) {
            return (
                <React.Fragment>
                    <div className="form-group row mt-4 text-left">
                        <label className="col-3 col-md-2">CPF/CNPJ:</label>
                        <div className="col-9 col-md-4 mb-3">
                            <input type="text" className="form-control"
                                name="cpf"
                                {...this.props}
                                value={this.props.value.cpfCnpj} />
                        </div>
                    </div>
                </React.Fragment>
            )
        } else {
            return (
                <React.Fragment>
                    <div className="form-group row mt-4 text-left">
                        <label className="col-3 col-md-2">CPF/CNPJ:</label>
                        <div className="col-9 col-md-4 mb-3">
                            <input type="text" className="form-control"
                                name="cpf"
                                {...this.props}
                                value="------------" />
                        </div>
                    </div>
                </React.Fragment>
            )
        }
    }
}